import { FC } from 'react';

import { IconProps } from '../types';

export const PaperPlayIcon: FC<IconProps> = ({
	size,
	height = 22,
	width = 18,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 18 22"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M11.5 0c.266 0 .52.11.707.29l5.5 5.5c.188.19.293.45.293.71V19c0 1.65-1.346 3-3 3H3c-1.654 0-3-1.35-3-3V3c0-1.65 1.346-3 3-3h8.5ZM10 2H3c-.551 0-1 .45-1 1v16c0 .55.449 1 1 1h12c.552 0 1-.45 1-1V8h-5c-.553 0-1-.45-1-1V2ZM6.507 9.13c.313-.18.699-.17 1.007.01l5 3a1.006 1.006 0 0 1 .001 1.72l-5 3c-.159.09-.337.14-.515.14a1.004 1.004 0 0 1-1-1v-6c0-.36.194-.69.507-.87ZM12 2.91V6h3.086L12 2.91Z"
		/>
	</svg>
);
